import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Container,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import StudentFormService from "../../services/KangarooServices/StudentFormService";
import toast from "react-hot-toast";

const ClearStudentForm = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleClearForm = async () => {
    try {
      const response = await StudentFormService.clearData();
      toast.success(response);
      toggleModal();
    } catch (error) {
      console.error(error);
      toast.error("Failed to clear form data.");
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Clear Student Form" pageTitle="Settings" />
        <div className="d-flex justify-content-center align-content-center align-items-center">
          <Card className="shadow-sm border-0 col-6 mx-auto">
            <CardBody className="text-center py-5">
              <h5 className="text-danger mb-3">Clear Student Form Data</h5>

              {/* What it is */}
              <p className="mb-2">
                This feature allows you to reset the student form completely,
                removing all previously entered data in one click.
              </p>

              {/* What it will do */}
              <p className="mb-2">
                When you click "Clear Form", all information such as student
                names, contact details, addresses, and other inputs will be
                erased from the form fields.
              </p>

              {/* Effect / consequence */}
              <p className="mb-4 text-muted">
                ⚠️ Important: This action cannot be undone. Make sure you have
                saved any important data before proceeding. Once cleared, you
                will start with a fresh, empty form.
              </p>

              <Button color="danger" onClick={toggleModal}>
                Clear Form
              </Button>
            </CardBody>
          </Card>
        </div>

        {/* Confirmation Modal */}
        <Modal isOpen={modalOpen} toggle={toggleModal} centered>
          <ModalHeader toggle={toggleModal}>
            {/* <FiAlertTriangle className="me-2 text-warning" /> */}
            Confirm Clear Form
          </ModalHeader>
          <ModalBody>
            Are you sure you want to clear all student form data? This action
            cannot be undone.
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
            <Button color="danger" onClick={handleClearForm}>
              Yes, Clear
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default ClearStudentForm;
